import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_AUTHOR_DISPLAY_CLASSNAME } from './BlogAuthorDisplay.constants';
import { formatAuthor } from '../../../../services/blog';
import { classNames } from '../../../../utils/classname';
var defaultProps = {
  author: {},
  className: ''
};
export default function BlogAuthorDisplay(_ref) {
  var _classNames;
  var author = _ref.author,
    className = _ref.className;
  if (_isEmpty(author)) {
    return null;
  }
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_AUTHOR_DISPLAY_CLASSNAME, true), _defineProperty(_classNames, className, true), _classNames));
  return /*#__PURE__*/React.createElement("span", {
    className: finalClassName
  }, formatAuthor(author));
}
BlogAuthorDisplay.defaultProps = defaultProps;